// src/pages/RegistroCaviPage.js
// Vista gestionale aggregata di tutti gli Ordine Cavi dell'organizzazione — sola
// consultazione; la creazione e la modifica avvengono solo dal tab "Ordine Cavi" di ciascuna
// commessa. Stesso principio di Registro Rientri Materiali e degli altri registri.
import React, { useState, useEffect } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useOrg } from "../contexts/OrgContext";
import PrimoAccessoSezione from "../components/PrimoAccessoSezione";
import { Search, Lock } from "lucide-react";

export default function RegistroCaviPage({ onNavigate }) {
  const { effectiveOrgId } = useOrg();
  const [ordini, setOrdini] = useState([]);
  const [cerca, setCerca] = useState("");
  const [filtroStato, setFiltroStato] = useState("");

  useEffect(() => {
    if (!effectiveOrgId) return;
    return onSnapshot(query(collection(db, "ordiniCavi"), where("orgId", "==", effectiveOrgId)),
      snap => setOrdini(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, [effectiveOrgId]);

  const filtrati = ordini
    .filter(o => !filtroStato || o.stato === filtroStato)
    .filter(o => !cerca.trim() || (o.projectNome||"").toLowerCase().includes(cerca.toLowerCase()) || (o.riferimento||"").toLowerCase().includes(cerca.toLowerCase()) || (o.codiceCommessa||"").toLowerCase().includes(cerca.toLowerCase()))
    .sort((a,b) => (b.updatedAt?.seconds||0) - (a.updatedAt?.seconds||0));

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <h2 style={{ fontSize: 18, fontWeight: 800, color: "#1e1b4b", marginBottom: 2 }}>🔀 Registro Cavi</h2>
      <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 18 }}>Tutti gli Ordine Cavi dell'organizzazione — la modifica avviene solo dal tab della commessa.</p>

      <PrimoAccessoSezione sezioneId="registro-cavi"/>

      <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
          <Search size={13} style={{ position: "absolute", left: 10, top: 9, color: "#9ca3af" }} />
          <input value={cerca} onChange={e=>setCerca(e.target.value)} placeholder="Cerca per commessa o riferimento..."
            style={{ width: "100%", padding: "7px 10px 7px 30px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 12.5, boxSizing: "border-box" }} />
        </div>
        <select value={filtroStato} onChange={e=>setFiltroStato(e.target.value)}
          style={{ padding: "7px 10px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 12.5 }}>
          <option value="">Tutti gli stati</option>
          <option value="bozza">Bozza</option>
          <option value="inviato">Inviato</option>
        </select>
      </div>

      {filtrati.length === 0 ? (
        <div style={{ textAlign: "center", padding: 40, color: "#9ca3af", fontSize: 12.5 }}>Nessun ordine cavi trovato.</div>
      ) : filtrati.map(o => (
        <div key={o.id} onClick={() => onNavigate && onNavigate({ page: "project", projectId: o.projectId, project: { id: o.projectId, name: o.projectNome }, initialTab: "ordine-cavi" })}
          style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, marginBottom: 6, cursor: onNavigate ? "pointer" : "default" }}>
          <span style={{ fontSize: 18 }}>🔀</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>
              {o.codiceCommessa ? `[${o.codiceCommessa}] ` : ""}{o.projectNome || "Commessa"} {o.riferimento ? <span style={{ color: "#9ca3af", fontWeight: 500 }}>· {o.riferimento}</span> : ""}
            </div>
            <div style={{ fontSize: 11, color: "#6b7280" }}>
              {o.stato === "inviato" ? `Inviato${o.inviatoDaNome ? ` da ${o.inviatoDaNome}` : ""}${o.inviatoData ? ` il ${new Date(o.inviatoData+"T00:00:00").toLocaleDateString("it-IT")}` : ""}` : "In bozza"}
              {o.nota ? ` · Nota: ${o.nota}` : ""}
            </div>
          </div>
          {o.stato === "inviato"
            ? <span style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 700, color: "#6d28d9", background: "#f5f3ff", padding: "2px 8px", borderRadius: 6 }}><Lock size={10}/> INVIATO</span>
            : <span style={{ fontSize: 10, fontWeight: 700, color: "#6b7280", background: "#f3f4f6", padding: "2px 8px", borderRadius: 6 }}>BOZZA</span>}
        </div>
      ))}
    </div>
  );
}
